import React from "react";
import { useLocation } from "react-router-dom";
import "./BlogDetails.css";
import AuthorBox from "./AuthorBox";

const BlogsDetailsPage = () => {
  const { state: blog } = useLocation();

  if (!blog) {
    return (
      <div className="container mt-5 d-flex justify-content-center">
        <img src="/not-found.png" alt="Not Found" />
      </div>
    );
  }

  const publishedDate = new Date(blog.publishedAt).toLocaleDateString("en-US", {
    dateStyle: "full",
    timeZone: "Asia/Karachi",
  });

  return (
    <div className="container">
      <div className="blog-layout">
        <div className="main-content">
          <div className="blog-card">
            <img src={blog.blog_image.url} alt="Blog Thumbnail" className="blog-image" />
            <h1 className="blog-title">{blog.title}</h1>
            <p className="blog-date">{publishedDate}</p>
            <hr className="divider" />
            <div className="blog-content">
              <p>{blog.description}</p>
            </div>
            <AuthorBox singlePost={blog} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogsDetailsPage;
